import MayorLoader from './MayorLoader'

export default MayorLoader
